//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Spinner from "../../../shared/Spinner";
export default {
    components: { Spinner: Spinner },
    props: {
        resident: {
            required: true,
            type: Object
        }
    },
    data: function data() {
        return {
            modalName: 'move-out',
            step: 1,
            showLoader: {
                moveout: false
            },
            preventPayPortal: false,
            preventAllPortal: false,
            noticeEvent: {
                notice: {},
                resident: {},
                pro_rate_transactions: [],
                recurring_transactions: []
            },
            showCancel: false // @NOTE: this is being abused to do a check on future dated move outs
        };
    },

    computed: {
        totalTransactions: function totalTransactions() {
            if (!this.noticeEvent || !this.noticeEvent.pro_rate_transactions.length && !this.noticeEvent.relet_fee) return 0;

            var total = 0;
            var relet = this.noticeEvent.relet_fee ? this.noticeEvent.relet_fee : 0;
            this.noticeEvent.pro_rate_transactions.forEach(function (item) {
                total += item.prorated_amount;
            });

            return total + relet;
        },
        recurringCharges: function recurringCharges() {
            return this.noticeEvent.recurring_transactions.filter(function (item) {
                return item.type === 'Recurring';
            });
        },

        hasRecurringCharges: function hasRecurringCharges() {
            return this.recurringCharges.length;
        },
        oneTimeCharges: function oneTimeCharges() {
            if (!this.noticeEvent || !this.noticeEvent.pro_rate_transactions) {
                return [];
            }

            return this.noticeEvent.pro_rate_transactions.filter(function (item) {
                return item.type === 'One-Time';
            });
        },

        hasOneTimeCharges: function hasOneTimeCharges() {
            return this.oneTimeCharges.length;
        }
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('move-out', function () {
            _this.noticeEvent = _this.getNoticeEvent(_this.resident.latest_notice_event.id_notice_events);
            _this.resident.lease = _this.getActiveLease(_this.resident.leases);
            Event.$emit('open-slide', _this.modalName);
        });

        Event.$on('close-full-modal', function () {
            Object.assign(_this.$data, _this.$options.data());
            _this.cancel();
        });
        Event.$on('future-move-out', function () {
            _this.sendMoveOut();
        });
    },

    methods: {
        getActiveLease: function getActiveLease(leases) {
            if (leases.length === 0) return null;

            // look for first active, or else first lease
            var activeLeaseIndex = leases.findIndex(function (e) {
                return e.active === 1;
            });
            if (activeLeaseIndex > -1) {
                return leases[activeLeaseIndex];
            }
            return leases[0];
        },
        getNoticeEvent: function getNoticeEvent(noticeEventId) {
            var _this2 = this;

            axios.get("/prototype/person/residents/notice-events/" + noticeEventId).then(function (response) {
                if (response.data.error) {
                    _this2.$snotify.error("Error pulling notice event: " + response.data.error);
                } else {
                    _this2.noticeEvent = response.data;
                }
            });
        },
        dateFilter: function dateFilter(value) {
            if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
        },
        cancel: function cancel() {
            Event.$emit('close-slide', this.modalName);
        },
        checkMoveOut: function checkMoveOut() {
            //show warning if future estimated_moveout_date
            var showWarning = moment(this.noticeEvent.notice.estimated_moveout_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD');

            if (showWarning) {
                Event.$emit('cancel-notice');
            } else {
                this.sendMoveOut();
            }
        },
        sendMoveOut: function sendMoveOut() {
            var _this3 = this;

            var today = moment().format('YYYY-MM-DD');
            var moveOutDate = moment(this.noticeEvent.notice.estimated_moveout_date).format('YYYY-MM-DD') < today ? moment(this.noticeEvent.notice.estimated_moveout_date).format('YYYY-MM-DD') : today;

            //show warning if future estimated_moveout_date
            // let showWarning = (moveOutDate > today);

            var payload = {
                residentId: this.resident.id,
                noticeEventId: this.noticeEvent.notice.id_notice_events,
                moveOutDate: moveOutDate,
                unitId: this.resident.unit_id,
                leaseId: this.resident.lease.id,
                relet_fee: this.noticeEvent.relet_fee,
                prevent_access: this.preventAllPortal ? 'all' : this.preventPayPortal ? 'payment' : ''
            };
            this.showLoader.moveout = true;
            axios.post('/prototype/person/residents/move-outs', payload).then(function (response) {
                _this3.showLoader.moveout = false;
                if (response.data.error) {
                    _this3.$snotify.error("Error saving Notice Event: " + response.data.error);
                } else {
                    _this3.$snotify.success("Move out saved successfully.");
                    Event.$emit('close-slide', _this3.modalName);
                    Event.$emit('refresh-resident-dashboard', _this3.resident);
                    Event.$emit('show-resident-list');
                    Event.$emit('past-resident-list-updated');
                    Event.$emit('show-move-out-alerts');
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/move-outs/MoveOut.vue
// module id = 5tdT
// module chunks = 0 1